import AuthenticationService from './../../services/AuthenticationService'
import Store from '@/store'

const company = {
  namespaced: true,
  state: {
    datas: {},
    data: [],
    loading: false,
    queryParam: null
  },
  getters: {
    getCompanies (state) {
      return state.data
    }
  },
  mutations: {
    SET_DATAS (state, data) {
      state.datas = data
    },
    SET_DATA (state, data) {
      state.data = data
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_QUERY_PARAM (state, data) {
      state.queryParam = data
    }
  },
  actions: {
    async reqDataCompany ({ commit }) {
      commit('SET_LOADING', true)
      return await AuthenticationService.get('company').then(({ data }) => {
        commit('SET_DATA', data.data)
        commit('SET_LOADING', false)
      })
    },
    async paginate ({ commit }, payload) {
      commit('SET_LOADING', payload.loading)
      commit('SET_QUERY_PARAM', payload.datas)
      return await AuthenticationService.get('company/paginate?' + payload.datas).then(({ data }) => {
        commit('SET_DATAS', data.data)
        commit('SET_DATA', data.data.data)
        commit('SET_LOADING', false)
      })
    },
    onRefresh ({ state }) {
      Store.dispatch('company/paginate', { loading: true, datas: state.queryParam })
    }
  }
}

export default company
